import { render } from "./curriculumDetails.vue?vue&type=template&id=3fa035fa"
import script from "./curriculumDetails.vue?vue&type=script&lang=js"
export * from "./curriculumDetails.vue?vue&type=script&lang=js"

import "./curriculumDetails.vue?vue&type=style&index=0&id=3fa035fa&lang=less"

import exportComponent from "/Users/user/mscode/tecs/TECS-FE-ENDUSER-NEW/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__